<style lang="scss" scoped>
@import "$vars";

.tooltip {
  overflow: visible;
  text-overflow: visible;
  text-transform: initial !important;
  // &::after {
    // background: #FDF9C8;
    // color: #4a4a4a;
    // border-radius: 2px;
    // box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16);
    // padding: 0.2rem;
    // margin-bottom: 0.5rem;
  // }
  &:focus,
  &:hover {
    &::after {
      opacity: 1;
      transform: translate(-10%, -$unit-1);
    }
  }
  .v-icon {
    display: inline-block;
    float: none;
    margin-left: 7px;
    height: 15px;
    width: 15px;
  }
}
</style>

<template>
  <span class="tooltip tooltip-top" :data-tooltip="text">
    <dr-icon class="v-icon" color="silver" name="info" key="tooltip_2"></dr-icon>
  </span>
</template>

<script>
export default {
  props: ['text']
}
</script>
